import { Button, Flex, Link, Text, Center } from "@chakra-ui/react";

import { BANNER_DATA, KERNEL_BANNER_DATA } from "@constants/banner";
import useBanner from "@hooks/useBanner";

type TBanner = {
  variant: number; //1=Default 2=Kernel
};

const Banner = ({ variant = 1 }: TBanner) => {
  const { showBanner } = useBanner(variant);

  if (!showBanner) {
    return null;
  }

  const renderCTAText = () => {
    return (
      <Flex
        justifyContent={"center"}
        alignItems={"center"}
        borderRadius="6px"
        textAlign={"center"}
        h="24px"
        // textDecoration={"underline"}
        whiteSpace="nowrap"
      >
        <Text fontWeight="500" lineHeight="28px" borderColor="textPrimary">
          {KERNEL_BANNER_DATA.cta_text}
        </Text>
      </Flex>
    );
  };

  const renderBanner = () => {
    switch (variant) {
      case 1: //KELP DEFAULT
        return (
          <Center
            w="100%"
            bg="#075A5A"
            fontSize={{ base: "12px", md: "14px" }}
            pos="relative"
            top="0"
            zIndex={7}
            p="8px"
            px={{ base: "16px", lg: "68px" }}
          >
            <Flex
              color="#FFF"
              fontWeight="500"
              lineHeight="140%"
              alignItems="center"
              justifyContent="center"
              textAlign="center"
              gap={{ base: "8px", md: "16px" }}
              w="100%"
            >
              <Text
                textAlign="left"
                dangerouslySetInnerHTML={{
                  __html: BANNER_DATA.text,
                }}
              />
              {BANNER_DATA.cta_text && BANNER_DATA.cta_link ? (
                <Link
                  isExternal
                  href={BANNER_DATA.cta_link}
                  minW="75px"
                  _hover={{ textDecoration: "none" }}
                >
                  <Button
                    p={{ base: "6px", md: "6px 12px" }}
                    bg="#FFF"
                    borderRadius="6px"
                    textDecor="none"
                    h="24px"
                  >
                    <Text
                      fontSize="10px"
                      fontWeight="600"
                      lineHeight="12px"
                      borderColor="textPrimary"
                    >
                      {BANNER_DATA.cta_text}
                    </Text>
                  </Button>
                </Link>
              ) : null}
            </Flex>
          </Center>
        );
      case 2: //KERNEL AIRDROP
        return (
          <Center
            w="100%"
            bg="#FFA28D"
            fontSize={{ base: "12px", md: "14px" }}
            pos="relative"
            top="0"
            zIndex={7}
            p="6px"
            px={{ base: "16px", lg: "68px" }}
          >
            <Flex
              color="#571B0D"
              fontWeight="500"
              lineHeight="140%"
              alignItems="center"
              justifyContent="center"
              textAlign="center"
              gap="4px"
              w="100%"
            >
              <Flex
                alignItems={"center"}
                justifyContent={{ base: "start", md: "center" }}
                flexWrap="wrap"
              >
                {!!KERNEL_BANNER_DATA.text1 && (
                  <Text textAlign="left">{KERNEL_BANNER_DATA.text1}</Text>
                )}
                {!!KERNEL_BANNER_DATA.text2 && (
                  <Text textAlign="left" fontWeight={500}>
                    {KERNEL_BANNER_DATA.text2}
                  </Text>
                )}
              </Flex>
              {KERNEL_BANNER_DATA.cta_link ? (
                <Link
                  isExternal
                  href={KERNEL_BANNER_DATA.cta_link}
                  minW="75px"
                  textDecor="underline"
                >
                  {renderCTAText()}
                </Link>
              ) : (
                renderCTAText()
              )}
            </Flex>
          </Center>
        );
      default:
        return null;
    }
  };

  return renderBanner();
};

export default Banner;
